import { EVENTS } from '@archetype-themes/utils/events'
import { HTMLThemeElement } from '@archetype-themes/custom-elements/theme-element'

class ProductInventoryBadge extends HTMLThemeElement {
  constructor() {
    super()

    this.classes = {
      hidden: 'hide'
    }

    this.selectors = {
      variantJson: '[data-current-variant-json]',
      inventoryBadge: '[data-product-inventory-badge]',
      inventories: '[data-inventories-json]'
    }

    this.updateInventoryBadge = this.updateInventoryBadge.bind(this)
  }

  connectedCallback() {
    this.abortController = new AbortController()

    this.productId = this.dataset.productId
    this.currentVariant = JSON.parse(this.querySelector(this.selectors.variantJson).textContent)
    const badgeEl = this.querySelector(this.selectors.inventoryBadge)
    this.settings = {
      inventoryThreshold: parseInt(badgeEl.dataset.threshold) || 10
    }

    // Update inventory badge on page load
    this.updateInventoryBadge({ detail: { variant: this.currentVariant } })

    document.addEventListener(
      `${EVENTS.variantChange}:${this.dataset.sectionId}:${this.productId}`,
      this.updateInventoryBadge,
      { signal: this.abortController.signal }
    )
  }

  disconnectedCallback() {
    this.abortController.abort()
  }

  updateInventoryBadge(evt) {
    const variant = evt.detail.variant
    const badgeEl = this.querySelector(this.selectors.inventoryBadge)

    if (!variant || !badgeEl) {
      return
    }

    // If variant has no inventory management, hide badge
    if (!variant.inventory_management) {
      badgeEl.classList.add(this.classes.hidden)
      return
    }

    if (variant.inventory_management === 'shopify' && this.getInventories()) {
      const variantInventoryObject = this.getInventories()[variant.id]

      if (!variantInventoryObject) {
        badgeEl.classList.add(this.classes.hidden)
        return
      }

      const { quantity } = variantInventoryObject

      // Show badge if inventory is below threshold and above 0
      if (parseInt(quantity) <= this.settings.inventoryThreshold && parseInt(quantity) > 0) {
        badgeEl.classList.remove(this.classes.hidden)
      } else {
        badgeEl.classList.add(this.classes.hidden)
      }
    } else {
      badgeEl.classList.add(this.classes.hidden)
    }
  }

  getInventories() {
    this.inventories = this.inventories || JSON.parse(this.querySelector(this.selectors.inventories).textContent)
    return this.inventories
  }
}

customElements.define('product-inventory-badge', ProductInventoryBadge)